    var gmarkers = [];

    function initMap() {                 
        var $element = $('#locations');
        if (!$element.length) {
            return;
        }

        var styles = [
            {
                "featureType": "all",
                "elementType": "geometry",
                "stylers": [
                    {
                        "saturation": "47"
                    },
                    {
                        "lightness": "0"
                    },
                    {
                        "gamma": "1"
                    },
                    {
                        "hue": "#006dff"
                    },
                    {
                        "weight": "1"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            }
        ];




        //MAP
        var cityKoprivnica = {lat:46.163510, lng:16.829814 };
        
        var map = new google.maps.Map(document.getElementById('locations'), {
            zoom: 15,
            maxZoom: 15,
            center: cityKoprivnica,
            scrollwheel: true,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            styles: styles
        });

        var infowindow = new google.maps.InfoWindow();
        setMarkers(map, infowindow);

        
        $('.js_filterLocations').on("change", function(){
            setMarkers(map, infowindow);
        })
    }


    function setMarkers(map, infowindow) {
        var icon = "/wp-content/themes/gradzazivot/images/icons/ico-pin.svg";
        var bounds = new google.maps.LatLngBounds();
        var id = $(".js_filterLocations option").filter(":selected").val();

        $(".map").append('<div class="preloader"><i class="preloader__icon"></i></div>');

        $.ajax({
            url: "/wp-json/map/v1/locations/",
            type: "POST",
            data: {id: id},
            success: function(data) {
                //console.log(data);

                $(".map .preloader").fadeOut(200, function(){
                    $(this).remove();
                });

                removeMarkers();

                if (data.length>0) {
                    for (i = 0; i < data.length; i++) {  
                        marker = new google.maps.Marker({
                            position: new google.maps.LatLng(data[i]["coordinates"]["latitude"], data[i]["coordinates"]["longitude"]),
                            map: map,
                            icon: icon
                        });

                        gmarkers.push(marker);

                        google.maps.event.addListener(marker, 'click', (function(marker, i, infowindow) {
                            return function() {
                                var content = data[i]["content"];

                                infowindow.setContent(content);
                                infowindow.open(map, marker);
                            }
                        })(marker, i, infowindow));

                        bounds.extend(marker.getPosition());
                    }

                    map.fitBounds(bounds);
                } 
            }            
        });
    }



    function initMapTraffic() {      
        var $element = $('#locations');
        if (!$element.length) {
            return;
        }

        var styles = [
            {
                "featureType": "all",
                "elementType": "geometry",
                "stylers": [
                    {
                        "saturation": "47"
                    },
                    {
                        "lightness": "0"
                    },
                    {
                        "gamma": "1"
                    },
                    {
                        "hue": "#006dff"
                    },
                    {
                        "weight": "1"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            }
        ];




        //MAP
        var cityKoprivnica = {lat:46.163510, lng:16.829814 };
        
        var map = new google.maps.Map(document.getElementById('locations'), {
            zoom: 15,
            maxZoom: 15,
            center: cityKoprivnica,
            scrollwheel: true,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            styles: styles
        });

        setMarkersTraffic(map);
    }


    function setMarkersTraffic(map) {
        var bounds = new google.maps.LatLngBounds();

        $(".map").append('<div class="preloader"><i class="preloader__icon"></i></div>');

        $.ajax({
            url: "/wp-json/map/v1/locations_traffic/",
            type: "POST",
            success: function(data) {
                console.log(data);

                $(".map .preloader").fadeOut(200, function(){
                    $(this).remove();
                });

                removeMarkers();

                if (data.length>0) {
                    for (i = 0; i < data.length; i++) {
                        marker = new google.maps.Marker({
                            position: new google.maps.LatLng(data[i]["coordinates"]["latitude"], data[i]["coordinates"]["longitude"]),
                            map: map,
                            icon: data[i]["icon"]
                        });

                        gmarkers.push(marker);

                        google.maps.event.addListener(marker, 'click', (function(marker, i) {
                            return function() {
                                $id = data[i]["id"];
                                $('.map .map__popups').addClass('show');
                                $('.map .map__popups_item').removeClass('active');
                                $('.map .map__popups [data-id="'+$id+'"]').addClass('active');
                            }
                        })(marker, i));

                        google.maps.event.addListener(map, 'click', function(event){
                            $('.map .map__popups').removeClass('show');
                        });

                        bounds.extend(marker.getPosition());
                    }

                    map.fitBounds(bounds);
                } 
            }            
        });
    }


    function removeMarkers(){
        for(i=0; i<gmarkers.length; i++){
            gmarkers[i].setMap(null);
        }
    }


    // CLOSE SIDEBAR
    $("[data-close-sidebar]").on("click", function(){
        $('.map .map__popups').removeClass('show');
    })